import {
  orderBy, sumBy, find, ceil,
  map, isEmpty, filter, isNil, get,
} from 'lodash';

export function getCatPage(state, getters) {
  return state.catPages && state.catPages[getters.getCatQuizResultPageId];
}

export function getCitationsCount(state, getters) {
  return get(getters.getCatPage, 'page_citation.teachers_count') || 0;
}

export function getCatPages(state) {
  return state.catPages || {};
}

export function getCatPagesId(state, getters) {
  return getters.getCatPage && getters.getCatPage.id;
}

export function getCatPagesIdList(state) {
  return state.catPageIdList || [];
}

export function getCatPagePosition(state) {
  return state.pagination.page;
}

export function getCatPagesPagination(state) {
  return state.pagination;
}

export function getCatPageOptions(state, getters) {
  return orderBy(getters.getCatPage && getters.getCatPage.answers, ['id'], ['asc']);
}

export function getCorrectCatOptionIndex(state, getters) {
  if (
    isEmpty(getters.getCatPageOptions)
    || isNil(getters.getCatPageCorrectAnswerId)
  ) {
    return null;
  }

  return getters.getCatPageOptions.findIndex(option => (
    option.id === getters.getCatPageCorrectAnswerId
  )) + 1;
}

export function getCatPageCorrectAnswerId(state, getters) {
  if (isEmpty(getters.getCatQuizResult)) {
    return null;
  }

  if (!isEmpty(getters.getCatQuizResult.correct_answers)) {
    return getters.getCatQuizResult.correct_answers[0].id;
  }

  if (!isEmpty(getters.getCatPageCorrectAnswerOptions)) {
    return getters.getCatPageCorrectAnswerOptions[0].id;
  }

  return null;
}

export function getCatPageCorrectAnswerOptions(state, getters) {
  if (!isEmpty(getters.getCatQuizResult.correct_answers)) {
    return getters.getCatQuizResult.correct_answers;
  }

  const correctAnswerOptions = filter(getters.getCatPageOptions, { is_correct: true });
  return correctAnswerOptions || [];
}

export function getSelectedCatOptionIndex(state, getters) {
  if (isEmpty(getters.getCatPageOptions)) {
    return null;
  }

  const selectedCatOptionIndex = getters.getCatPageOptions.findIndex(option => (
    option.id === getters.getSelectedOptionId
  )) + 1;

  return selectedCatOptionIndex || null;
}

export function getCatPageCorrectAnswerContents(state, getters) {
  if (isEmpty(getters.getCatQuizResult)) {
    return null;
  }

  return map(getters.getCatPageCorrectAnswerOptions, 'content').join(', ');
}

export function getCatQuizAnswerValue(state, getters) {
  return getters.getCatQuizResult && getters.getCatQuizResult.value;
}

export function getSelectedOptionId(state, getters) {
  return getters.getCatQuizResult ?
    getters.getCatQuizResult.answer_id :
    null;
}

export function getSelectedOption(state) {
  return state.selectedOptions;
}

export function getRemainCatQuizResults(state, getters) {
  return getters.getCatCard.quiz_results && getters.getCatCard.quiz_results.length;
}

export function getIsCatOptionsBlank(state, getters) {
  return getters.getCatPage &&
    getters.getCatPage.answers &&
    getters.getCatPage.answers.every(answer => !answer.content);
}

export function getCatQuizStartTime(state) {
  return state.startTime.getTime();
}

export function getCurrentDate(state) {
  return state.currentDate;
}

export function getMonitoringHistories(state) {
  return state.monitoringHistories;
}

export function getPageQuizResultCache(state) {
  return state.pageQuizResultCache || {};
}

export function getAverageDuration(state, getters) {
  const correctAnswerCount = getters.getPageQuizResultCache.correct_count || 0;
  const correctAnswerDuration = getters.getPageQuizResultCache.correct_duration || 0;
  return correctAnswerCount > 0 ? ceil(correctAnswerDuration / correctAnswerCount) : null;
}

export function getCorrectAnswerRate(state, getters) {
  const correctAnswerCount = getters.getPageQuizResultCache.correct_count || 0;
  const totalAnswerCount = getters.getPageQuizResultCache.total_count;
  return totalAnswerCount > 0 ? ceil((correctAnswerCount / totalAnswerCount) * 100) : null;
}

export function getCatPageAnswerOptions(state, getters) {
  if (!isEmpty(getters.getCatQuizResult)) {
    return map(getters.getCatPageOptions, (item) => {
      if (item.id === getters.getCatPageCorrectAnswerId) {
        return {
          ...item,
          is_correct: true,
        };
      }

      return {
        ...item,
        is_correct: false,
      };
    });
  }

  return getters.getCatPageOptions;
}

export function getPageAnswerStatistics(state, getters) {
  const results = map(getters.getCatPageAnswerOptions, (item) => {
    const answerStatistic = find(state.pageAnswerStatistics, { answer_id: item.id });
    if (!isEmpty(answerStatistic)) {
      return {
        ...item,
        count: answerStatistic.count,
      };
    }

    return item;
  });

  return results || [];
}

export function getPageAnswerTotalCount(state, getters) {
  return sumBy(getters.getPageAnswerStatistics, 'count') || 0;
}

export function getCompletedCatQuizResults(state, getters) {
  if (isEmpty(getters.getCatQuizResults)) {
    return [];
  }

  return getters.getCatQuizResults;
}

export function getCatId(state, getters) {
  if (isEmpty(getters.getRouteParams)) {
    return null;
  }

  return getters.getRouteParams.catId;
}

export function isCatQuizResultsPage(state, getters) {
  return getters.getRouteName === 'catQuizResults';
}

export function isTeachingMode(state, getters) {
  return getters.isCatQuizResultsPage
    && getters.isTeacherUser
    && !getters.isBookmarkedQuizMode;
}

export function isBookmarkedQuizMode(state, getters) {
  return !isEmpty(getters.getRouteQuery.bookmark_group_id);
}
